module.exports = __webpack_public_path__ + "_/_/src/assets/firesafety/fire-extinguisher-CO2/legend.png";